import PlatformView from "@/views/platform/PlatformView";

export default { PlatformView }